import { AppState } from '../AppStateProvider/interfaces';

export const complete = (state: AppState) => {
	// Option 1: Preview-Setup
	const previewComplete =
		state.preview &&
		state.brand !== null &&
		state?.market?.prodUrl !== null &&
		state.device !== null;

	// Option 2: Normal-Setup
	const normalComplete =
		state.brand !== null &&
		(state.market?.prodUrl !== null || state.market?.qsUrl !== null) &&
		state.device !== null &&
		state.pairing;

	return previewComplete || normalComplete;
};
